import { Component } from 'react';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';

const companyNameFromSource = {
  1045: 'Everytrail',
  1049: 'Gpsies',
  1050: 'Ifootpath',
  1051: 'Trailscom'
};

const statusEnglishFromInitial = {
  R: 'Registered',
  P: 'Pending',
  D: 'Deleted'
};

class AcquiredContentInterface extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchInProgress: false,
      user: props.user || null,
      jobsStatuses: this.getResetForJobStatuses()
    };
  }

  retrieveUser(email) {
    this.setState({ searchInProgress: true });
    ServerCommunicationUtil.postApiEndpoint(
      '/acquired-content/user-search',
      { user_email: email },
      data => {
        const newJobsStatuses = this.getResetForJobStatuses();
        this.setState({ user: data.users[0], jobsStatuses: newJobsStatuses });
      },
      err => {
        if (err && err.status == 404) {
          alert('User not found');
        }
      },
      data => {
        this.setState({ searchInProgress: false });
      }
    );
  }

  handleJobStatusSuccess(data, source) {
    if (!data || !data.users) return;

    // if the job is complete, record it as such and remove timeout, otherwise just update the user counts
    const userJson = data.users[0];
    if (data.jobComplete) {
      const newJobsStatuses = this.state.jobsStatuses;
      window.clearInterval(newJobsStatuses[source].timeoutId);
      newJobsStatuses[source].status = 'complete';
      this.setState({ user: userJson, jobsStatuses: newJobsStatuses });
    } else {
      this.setState({ user: userJson });
    }
  }

  updateSearchKey = e => {
    this.setState({ searchKey: e.target.value.trim() });
  };

  getResetForJobStatuses() {
    return {
      1045: {
        status: 'idle',
        timeoutId: null
      },
      1049: {
        status: 'idle',
        timeoutId: null
      },
      1050: {
        status: 'idle',
        timeoutId: null
      },
      1051: {
        status: 'idle',
        timeoutId: null
      }
    };
  }

  handleJobStatusError(err, source) {
    const newJobsStatuses = this.state.jobsStatuses;
    window.clearInterval(newJobsStatuses[source].timeoutId);
    newJobsStatuses[source].status = 'errored';
    this.setState({ jobsStatuses: newJobsStatuses });
  }

  handleClearUserClick() {
    this.setState({ user: null, searchKey: '' });
  }

  handleUserSearchClick = () => {
    const email = this.state.searchKey;
    this.retrieveUser(email);
  };

  handleSoftDeleteProfileClick = () => {
    ServerCommunicationUtil.getApiEndpoint(
      `/acquired-content/remove/${this.state.user.id}`,
      {},
      () => {
        alert('User has been deleted successfully');
      },
      err => {
        alert(`An error occurred when attempting to soft delete the user`);
        console.error(err);
      },
      () => {}
    );
  };

  handleHardDeleteProfileClick = () => {
    if (!prompt("Are you sure you want to hard delete this user's account?  This cannot be undone.")) return;

    ServerCommunicationUtil.postApiEndpoint(
      `/api/alltrails/admin/users/${this.state.user.id}/hard-delete`,
      {},
      () => {
        alert(`Started a delete user data job. Please see the #support-alerts slack channel for more details.`);
      },
      err => {
        alert(`An error occurred when attempting to hard delete the user`);
        console.error(err);
      },
      () => {}
    );
  };

  handleExportDataClick = () => {
    ServerCommunicationUtil.postApiEndpoint(
      `/api/alltrails/admin/users/${this.state.user.id}/export`,
      {},
      () => {
        alert('Started an export user data job. Please see the #support-alerts slack channel for more details.');
      },
      err => {
        alert(`An error occurred when attempting to export the user's data`);
        console.error(err);
      },
      () => {}
    );
  };

  handleBranchGDPRClick = () => {
    window.open('https://gdpr.branch.io/hc/en-us/requests/new', '_blank');
  };

  handleActivatePendingClick = () => {
    ServerCommunicationUtil.postApiEndpoint(
      `/api/alltrails/admin/users/${this.state.user.id}/activate-pending`,
      {},
      () => {
        alert('Activated the pending user');
        this.handleUserSearchClick();
      },
      err => {
        alert('An error occurred when attempting to activate the pending user');
        console.error(err);
      },
      () => {}
    );
  };

  renderUserInfoAndContent() {
    if (this.state.user) {
      const status = this.state.user.status;
      const showActivateUser = status == 'P';
      const userInfoBlock = (
        <div className="localization-search-bar">
          <h2>User's Information</h2>
          <div>
            <label>Name: {`${this.state.user.firstName} ${this.state.user.lastName}`}</label>
            <label>
              From:{' '}
              {this.state.user.source && companyNameFromSource[this.state.user.source] ? companyNameFromSource[this.state.user.source] : 'AllTrails'}
            </label>
            <label>Status: {statusEnglishFromInitial[this.state.user.status]}</label>
            <label className="inline">AllTrails Profile: </label>
            <a href={`/members/${this.state.user.slug}`}>Link</a>
            {this.state.user.source && (
              <label>
                {companyNameFromSource[this.state.user.source]} Profile: {this.state.user.source_remote_link}
              </label>
            )}
            <label>Id: {this.state.user.id}</label>
            <label>Slug: {this.state.user.slug}</label>
          </div>
          <div>
            <span className="btn btn-slim blue rounded" onClick={this.handleExportDataClick}>
              Export Account Data
            </span>
            <span className="btn btn-slim blue rounded" onClick={this.handleBranchGDPRClick}>
              Branch GDPR Request
            </span>
            {showActivateUser && (
              <span id="activate-pending-user" className="btn btn-slim blue rounded" onClick={this.handleActivatePendingClick}>
                Activate Pending Account
              </span>
            )}
            <span className="btn btn-slim orange rounded" onClick={this.handleSoftDeleteProfileClick}>
              Soft Delete Account
            </span>
            <span className="btn btn-slim orange rounded" onClick={this.handleHardDeleteProfileClick}>
              Hard Delete Account
            </span>
          </div>
        </div>
      );

      return <div id="user-info-and-content">{userInfoBlock}</div>;
    }
  }

  render() {
    return (
      <div className="edition-details">
        <div className="trail-edit-form">
          <div className="localization-search-bar">
            <label>Please enter a User's email:</label>
            <input value={this.state.searchKey} onChange={this.updateSearchKey} />
            <span className="btn btn-slim blue rounded form-top" onClick={this.handleUserSearchClick}>
              {this.state.searchInProgress ? 'Searching...' : 'Search'}
            </span>
            {this.state.user && (
              <span className="btn btn-slim blue rounded form-top" onClick={this.handleClearUserClick}>
                Clear
              </span>
            )}
          </div>
          {this.renderUserInfoAndContent()}
        </div>
      </div>
    );
  }
}

export default AcquiredContentInterface;
